<template>
    <mm-select :options="options" v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
const options = [
	{
		value:'sent',
		label:'Sent',
		class:'status-sent'
	},
	{
		value:'unsent',
		label:'Unsent',
		class:'status-unsent'
	},
]

export default{
	data(){
		return {
			options,
		}
	},
	props:['value']
}
</script>